import { AdminPanelLayoutV2 } from '@/features/adminPanel/components/AdminPanelLayoutV2';
import { ExternalFormEditor } from '@/features/externalForm/components/ExternalFormEditor';
import { ROUTES } from '@/App/Router/routes';

export const ExternalFormPage = () => {
  return (
    <AdminPanelLayoutV2
      title='Formulario de autos'
      subtitle='Personaliza el formulario que tus clientes diligencian. Los cambios se ven al instante.'
      backLabel='Volver al panel'
      fallbackTo={ROUTES.ADMIN_PANEL}
    >
      <ExternalFormEditor />
    </AdminPanelLayoutV2>
  );
};
